import { useEffect, useState } from "react";

export default function BubbleIcon({ icon = "❤️", onComplete }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      if (onComplete) onComplete();
    }, 1500); // durata animazione

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!show) return null;

  return (
    <div className="bubble-icon">
      {icon}
      <style jsx>{`

      
        .bubble-icon {
          position: fixed;
          bottom: 100px;
          right: 50px;
          font-size: 3.5rem;
          animation: rise 1.5s ease-out forwards;
          z-index: 9999;
        } 
        /* .bubble-icon {
          position: fixed;
          top: 30%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 4rem;
          animation: rise 1.5s ease-out forwards;
          z-index: 9999;
        }*/
        @keyframes rise {
          0% {
            opacity: 0;
            transform: scale(0.5) translateY(0);
          }
          30% {
            opacity: 1;
            transform: scale(1.2) translateY(-20px);
          }
          100% {
            opacity: 0;
            transform: scale(0.8) translateY(-80px);
          }
        }
      `}</style>
    </div>
  );
}
